import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Category extends Bloc {

	constructor (src, ctx) {

		super("category", src, ctx);
		this.f = (src, ins) => [target => target.category && target.category === ins[0]];
		this.types = [Types.string];
	}
}